"use strict";

/*global
    jQuery
 */

/*eslint
    yoda: [2, "always"]
 */

/**
 * main.js
 *
 * Theme enhancements for a better user experience.
 */

var $ = jQuery;
jQuery(document).ready(function ($) {
  // Respect a reduced-motion preference: no autoplay, no transition.
  var reduceMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if ($(".swiper-container").length) {
    var swiper = new Swiper(".swiper-container", {
      loop: true,
      // WCAG 2.2.2 - autoplay must be pausable. It stops on hover, on keyboard
      // focus, and via the pause button rendered by hero_slider.php.
      autoplay: reduceMotion
        ? false
        : {
            delay: 10000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
          },
      speed: reduceMotion ? 0 : 300,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      a11y: {
        enabled: true,
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
        paginationBulletMessage: "Go to slide {{index}}",
      },
    });

    // Pause while any control inside the slider has keyboard focus.
    $(".swiper-container")
      .on("focusin", function () {
        if (swiper.autoplay && swiper.autoplay.running) {
          swiper.autoplay.stop();
          $(this).find(".swiper-autoplay-toggle").attr("aria-pressed", "true");
        }
      });

    $(".swiper-autoplay-toggle").on("click", function () {
      var $btn = $(this);
      var paused = "true" === $btn.attr("aria-pressed");

      if (paused) {
        swiper.autoplay && swiper.autoplay.start();
        $btn.attr("aria-pressed", "false");
      } else {
        swiper.autoplay && swiper.autoplay.stop();
        $btn.attr("aria-pressed", "true");
      }
    });
  }

  // Content carousels (image_carousel block). Separate from the hero: no
  // autoplay, so WCAG 2.2.2 needs no pause control, and each instance is
  // initialised on its own element so several can share a page.
  $(".image-carousel-swiper").each(function () {
    var el = this;

    new Swiper(el, {
      loop: true,
      autoplay: false,
      speed: reduceMotion ? 0 : 300,
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        prevEl: el.querySelector(".image-carousel-prev"),
        nextEl: el.querySelector(".image-carousel-next"),
      },
      a11y: {
        enabled: true,
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
        paginationBulletMessage: "Go to slide {{index}}",
      },
    });
  });

  var $menuToggle = $("header .menu-toggle");
  var $mobileNav = $("header .mobile-nav");

  function setMenu(open) {
    $mobileNav.toggleClass("menu-open", open);
    $("body").toggleClass("no-scroll-mobile", open);
    $menuToggle.attr("aria-expanded", open ? "true" : "false");
  }

  $menuToggle.on("click", function () {
    var open = !$mobileNav.hasClass("menu-open");
    setMenu(open);

    // Body scroll is locked while the menu is open, so focus has to follow it
    // in - and come back to the toggle when it closes.
    if (open) {
      $mobileNav.find("a, button").first().trigger("focus");
    } else {
      $menuToggle.trigger("focus");
    }
  });

  $(document).on("keydown", function (e) {
    if ("Escape" !== e.key) {
      return;
    }

    if ($mobileNav.hasClass("menu-open")) {
      setMenu(false);
      $menuToggle.trigger("focus");
    }

    $(".menu-toggle-arrow[aria-expanded='true']").each(function () {
      $(this).attr("aria-expanded", "false").siblings("ul.sub-menu").removeClass("submenu-open");
    });
  });

  $(document).on("click", ".menu-toggle-arrow", function (e) {
    e.preventDefault();

    var $btn = $(this);
    var submenu = $btn.siblings("ul.sub-menu");
    var willOpen = !submenu.hasClass("submenu-open");

    // Close all other submenus
    $("ul.sub-menu").not(submenu).removeClass("submenu-open");
    $(".menu-toggle-arrow").not($btn).attr("aria-expanded", "false");

    submenu.toggleClass("submenu-open", willOpen);
    $btn.attr("aria-expanded", willOpen ? "true" : "false");
  });

  // Toggle the review form and scroll
  $(".add-review-btn").on("click", function () {
    $("#review_form").toggleClass("d-block");
    console.log("clicked");

    var element = document.querySelector(".review-section");
    if (this.classList.contains("review-button-clicked")) {
      this.classList.remove("review-button-clicked");
    } else {
      element.scrollIntoView({ behavior: "smooth" });
      this.classList.add("review-button-clicked");
    }
  });

  // open links to amazon in a new tab
  $(".product_type_external").attr("target", "_blank");

  // TikTok grid category filter (tiktok_grid block). Client-side only - the
  // post count is small, so toggling a class beats a round trip. Each block
  // is initialised on its own element so several can share a page.
  $(".tiktok-grid").each(function () {
    var $block = $(this);
    var $pills = $block.find(".tiktok-grid__pill");
    var $cards = $block.find(".tiktok-grid__card");

    if (0 === $pills.length) {
      return;
    }

    $pills.on("click", function () {
      var $pill = $(this);
      // The "All" pill carries an empty value, which matches every card.
      var category = $pill.attr("data-tiktok-filter") || "";

      $pills.removeClass("is-selected").attr("aria-pressed", "false");
      $pill.addClass("is-selected").attr("aria-pressed", "true");

      $cards.each(function () {
        var $card = $(this);
        var cardCategory = $card.attr("data-tiktok-category") || "";
        var match = "" === category || category === cardCategory;

        $card.toggleClass("is-hidden", !match);
      });
    });
  });
});

// Function to remove the size attribute from elements with the class 'size-woocommerce_thumbnail'
function removeSizeAttribute() {
  var elements = document.querySelectorAll(".size-woocommerce_thumbnail");
  elements.forEach(function (element) {
    element.removeAttribute("sizes");
  });
}

// Call the function to remove the size attribute
removeSizeAttribute();

var ccpaClick = document.querySelector("#ccpa .close");
var ccpaSeen = localStorage.getItem("ccpa-banner");
var ccpa = document.querySelector("#ccpa");

if (ccpa && ccpaClick && !ccpaSeen) {
  ccpa.classList.add("show");

  ccpaClick.addEventListener("click", function (e) {
    e.preventDefault();

    ccpa.classList.remove("show");
    localStorage.setItem("ccpa-banner", true);
  });
}

// Google Analytics - Track Add to Cart Events
var $addToCartBtn = $(".single_add_to_cart_button.button.alt");

// checking to see if the add to cart button exists on the page so were not firing errors on pages without products
if ($addToCartBtn.length) {
  // on click of add to cart button
  $addToCartBtn.click(function () {
    try {
      var $btn = $(this);
      var productId =
        $btn.data("product_id") ||
        $btn.closest("form.cart").find('input[name="product_id"]').val();
      var productTitle = $(".product_title.entry-title").text();
      var variation = $(".woo-selected-variation-item-name").text();
      var price = parseFloat(
        $(".woocommerce-variation-price").text().replace("$", "")
      );
      var quantity = parseInt($(".input-text.qty.text").val());

      // Send event to Google Analytics
      gtag("event", "add_to_cart", {
        currency: "USD",
        value: parseFloat((price * quantity).toFixed(2)),
        items: [
          {
            item_id:
              productId || productTitle + (variation ? " " + variation : ""),
            item_name: productTitle + (variation ? " " + variation : ""),
            price: price,
            quantity: quantity,
          },
        ],
      });
    } catch (e) {
      console.error("Error tracking add to cart event:", e);
    }
  });
}
